import React from 'react'

import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'

import classes from './CtaButtonListing.module.scss'

/** @type {import("./types").default} */
const CtaButtonListing = ({ children, variant = 'outlined', fullWidth = true, icon, ...rest }) => (
  <CtaButton className="CtaButtonListing" fullWidth={fullWidth} variant={variant} {...rest}>
    {children}
    {icon && <Icon className={classes.externalLinkIcon} icon={icon} size="16" />}
  </CtaButton>
)

export default CtaButtonListing
